import React, { FC, MutableRefObject, ReactNode } from 'react';
import AmountField, { ClassNameModifierProp } from 'src/inbox/components/AmountField';
import styles from './PriceItem.module.scss';

type Props = {
  children?: ReactNode;
  currencySymbol?: string;
  amountFieldRef?: MutableRefObject<HTMLInputElement | undefined>;
  fieldName?: string;
  withFieldLevelValidation?: boolean;
  readOnly?: boolean;
  classNameModifier?: ClassNameModifierProp;
};

const PriceItem: FC<Props> = ({
  children = 'Your Offer',
  currencySymbol,
  amountFieldRef,
  fieldName,
  withFieldLevelValidation,
  readOnly,
  classNameModifier,
}) => (
  <label
    htmlFor={fieldName}
    className={styles.root}
  >
    <span>
      {children}
    </span>
    <AmountField
      currencySymbol={currencySymbol}
      amountFieldRef={amountFieldRef}
      fieldName={fieldName}
      withFieldLevelValidation={withFieldLevelValidation}
      readOnly={readOnly}
      classNameModifier={classNameModifier}
    />
  </label>

);

export default PriceItem;
